import { MakeCall } from './createMakeCall';
import { Notifications } from './types/Notifications';
import { Language } from '@ha/intl';

const getNotifications =
  (makeCall: MakeCall) =>
  (languages: Language = Language.en) =>
    makeCall<Notifications>('GET', `/api/v2/notifications`, {
      query: { locale: languages },
    });
export { getNotifications };
